import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';

import App from './App.vue';
import router from './router';
import Toast from 'vue-toastification';

import './assets/main.scss';
import './assets/sass/main.scss';
import 'vue-toastification/dist/index.css';
/*import './assets/main.scss';

import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap';*/


const app = createApp(App);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DNS,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [import.meta.env.VITE_BASE_URL],
});

app.use(Toast).use(createPinia()).use(router).mount('#app');
